import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface EditUserParams {
  userId: string;
  userData: {
    firstName: string;
    lastName: string;
    visible?: boolean;
    deleted?: boolean;
  };
}

export const useEditUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ userId, userData }: EditUserParams) => {
      const result = await apiClient.user.editUser.mutation({
        params: { userId },
        body: userData,
      });
      if (result.status !== 200) throw result.body;
      return result.body;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users-list'] });
      toast.success('User updated successfully!');
    },
    onError: (error: any) => {
      showErrorToast(error, 'Error updating user!');
    },
  });
};
